import apiClient from "../api/client";
import {
  AppListResponseDto,
  DeviceDto,
  DeviceListResponseDto,
  ScreenshotListResponseDto,
  CommandResponseDto
} from "../types/devicemanagementtypes";

export const getAllDevices = () =>
  apiClient.get<DeviceListResponseDto>("/api/device-management/devices");

export const searchDevices = (search: string) =>
  apiClient.get<DeviceListResponseDto>(
    "/api/device-management/devices",
    {
      params: { search }
    }
  );

export const getDevicesPaged = (
  page: number,
  pageSize: number,
  search?: string
) => {
  const offset = (page - 1) * pageSize;

  return apiClient.get<DeviceListResponseDto>(
    "/api/device-management/devices",
    {
      params: {
        limit: pageSize,
        offset,
        ...(search ? { search } : {})
      }
    }
  );
};

export const getDeviceApps = (
  deviceId: string,
  search?: string,
  limit: number = 10,
  offset: number = 0
) =>
  apiClient.get<AppListResponseDto>(
    `/api/device-management/devices/${deviceId}/apps`,
    {
      params: {
        ...(search ? { search } : {}),
        limit,
        offset,
      },
    }
  );

export const takeScreenshot = (deviceId: string) =>
  apiClient.post<CommandResponseDto>(
    `/api/device-management/devices/${deviceId}/screenshot`
  );

export const getDeviceById = (deviceId: string) =>
  apiClient.get<DeviceDto>(
    `/api/device-management/devices/${deviceId}`
  );

export const getDeviceScreenshots = (deviceId: string) =>
  apiClient.get<ScreenshotListResponseDto>(
    `/api/device-management/devices/${deviceId}/screenshots`
  );

export const rebootDevice = (deviceId: string) =>
  apiClient.post<CommandResponseDto>(
    `/api/device-management/devices/${deviceId}/reboot`
  );
